<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="门店名称" prop="shopId">-->
<!--                <a-input v-model="queryParam.shopId" placeholder="门店名称" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="教练名称" prop="nickname">-->
<!--                <a-input v-model="queryParam.nickname" placeholder="请输入教练名称" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="门店名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入教练名称" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="教练姓名" prop="name">
                  <a-input v-model="queryParam.name" placeholder="请输入教练姓名" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
            <template >
              <a-col :md="8" :sm="24">
                <a-form-item label="教练手机号" prop="phone">
                  <a-input v-model="queryParam.phone" placeholder="请输入教练手机号" @pressEnter="handleQuery" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['shop:shopshop:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['shop:shopshop:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shop:shopshop:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['shop:shopshop:export']">
          <a-icon type="download" />导出
        </a-button>
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}" 
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="avatar" slot-scope="text, record">
       <img v-viewer style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.avatar"
       :src="record.avatar" preview="头像"/>
       </span>

        <div v-viewer slot="picture" slot-scope="text, record" v-if="record.picture" :style="{maxWidth: '180px',whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden', wordWrap: 'break-word', wordBreak: 'break-all' }" >
          <img   v-for="(pic) in record.picture.split(',')" style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
                :src="pic" preview="相关图片"/>
        </div>

        <!-- <div v-viewer slot="certificate" slot-scope="text, record" v-if="record.certificate" :style="{maxWidth: '180px',whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden', wordWrap: 'break-word', wordBreak: 'break-all' }" >
          <img  v-for="(pic) in record.certificate.split(',')" style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
                :src="pic" preview="相关证书"/>
        </div> -->

        <span v-viewer slot="video" slot-scope="text, record">
          <video  controls width="100" height="100">
          <source :src="record.video" type="video/mp4">
        </video>
      </span>


        <span slot="operation" slot-scope="text, record, index">
          <a-divider type="vertical" v-hasPermi="['shop:shopshop:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:shopshop:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shopshop:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['shop:shopshop:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageShopShop,listShopShop, delShopShop } from '@/api/coach/shopShop'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ShopShop',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
       //索引indexs
       indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        shopId: null,
        shopName: null,
        nickname: null,
        avatar: null,
        title: null,
        name: null,
        content: null,
        picture: null,
        video: null,
        certificate: null,
        phone: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
 
        {
          title: '教练名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },

        {
          title: '教练头像',
          dataIndex: 'avatar',
          ellipsis: true,
          scopedSlots: {customRender: 'avatar'},
          align: 'center'
        },
        {
          title: '教练手机号',
          dataIndex: 'phone',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '教练标题',
        //   dataIndex: 'title',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '教练姓名',
        //   dataIndex: 'name',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '个人简介',
        //   dataIndex: 'content',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '相关图片',
        //   dataIndex: 'picture',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'picture'},
        //   align: 'center'
        // },
        {
          title: '视频',
          dataIndex: 'video',
          ellipsis: true,
          scopedSlots: {customRender: 'video'},
          align: 'center'
        },
        // {
        //   title: '相关证书',
        //   dataIndex: 'certificate',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'certificate'},
        //   align: 'center'
        // },
        {
          title: '所属门店',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          
          align: 'center',
          width:100
        },

        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询门店教练列表 */
    getList () {
      this.loading = true
     pageShopShop(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {

      this.queryParam = {
        shopId: undefined,
        shopName: undefined,
        nickname: undefined,
        avatar: undefined,
        title: undefined,
        name: undefined,
        content: undefined,
        picture: undefined,
        video: undefined,
        certificate: undefined,
        phone: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
        // 列表顶部删除indexs
        if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delShopShop(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('shopshop/shop/export', {
            ...that.queryParam
          }, `门店教练_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
